module.exports = __webpack_public_path__ + "2aa7aa40a840868e2bc225275a25fd41.svg";